var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAxl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.797 10.916l4.187-4.183l-1.586-1.59L12 8.537L8.61 5.143L7.024 6.729l4.183 4.187a1.117 1.117 0 0 0 1.59 0m6.06 4.474l-3.39-3.394l3.386-3.39l-1.586-1.586l-4.183 4.183a1.12 1.12 0 0 0 0 1.586l4.183 4.187zM12 15.463l3.385 3.394l1.59-1.586l-4.182-4.187a1.12 1.12 0 0 0-1.59 0l-4.188 4.183l1.586 1.59zm-1.085-2.666a1.117 1.117 0 0 0 0-1.586L6.733 7.024L5.143 8.61l3.394 3.394l-3.394 3.39l1.585 1.586z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxl);
export default __webpack_public_path__ + "static/media/axl.0228db4b20d2ed87edbb4adc77493167.svg";
export { ForwardRef as ReactComponent };